var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "div",
    },
    [
      _c(
        "div",
        { staticClass: "div-top" },
        [
          _c("span", [_vm._v("日期：")]),
          _c("el-date-picker", {
            attrs: {
              type: "monthrange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "yyyy-MM-dd",
            },
            on: { change: _vm.handleDateChange },
            model: {
              value: _vm.rDate,
              callback: function ($$v) {
                _vm.rDate = $$v
              },
              expression: "rDate",
            },
          }),
          _c("el-input", {
            staticStyle: { width: "300px", "margin-left": "10px" },
            attrs: {
              value: `${_vm.MaterialName || ""}${
                _vm.MaterialCode ? "(" + _vm.MaterialCode + ")" : ""
              }`,
              clearable: "",
              placeholder: " 请点击右侧按钮选择备件信息",
              disabled: "",
            },
          }),
          _c(
            "el-button",
            {
              staticStyle: { width: "100px", "margin-left": "10px" },
              attrs: { type: "primary" },
              on: { click: _vm.addList },
            },
            [_vm._v("选择备件")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary" },
              on: { click: _vm.handleSearch },
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "warning", icon: "el-icon-download" },
              on: { click: _vm.handleExport },
            },
            [_vm._v("导出数据")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "div-center" },
        [
          _c(
            "el-table",
            {
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, height: "calc(100% - 40px)" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "50", type: "index" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "日期",
                  width: "200",
                  align: "center",
                  prop: "StorTime",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.StorTime
                                ? _vm
                                    .moment(scope.row.StorTime)
                                    .format("YYYY-MM-DD")
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单据类型",
                  width: "160",
                  align: "center",
                  prop: "Type",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "入库数量",
                  align: "center",
                  prop: "iQty",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "出库数量",
                  align: "center",
                  prop: "oQty",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "结存数量",
                  align: "center",
                  prop: "tQty",
                  sortable: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("Fittings", {
        ref: "Fittings",
        attrs: { type: "radio", MaterialType: _vm.FittingsTreeSearch },
        on: { select: _vm.FittingsChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }